function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  filter: "url(#filter0_i)"
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M50.5274 0.430487C51.0258 0.192723 51.4179 0.447531 51.4031 0.999616L50.7051 26.9603C50.6903 27.5124 50.2742 28.1527 49.7757 28.3904L31.4809 37.1166C31.3507 37.1787 31.2212 37.2713 31.1013 37.3879L14.2557 53.7783C13.6602 54.3576 13 54.2166 13 53.51L13 46.889C13 46.3557 12.6119 46.1167 12.1239 46.3494L1.0901 51.6123C0.591619 51.85 0.19955 51.5952 0.214393 51.0431L0.912334 25.0825C0.927177 24.5304 1.34331 23.8901 1.84179 23.6523L50.5274 0.430487ZM12.755 35.8795C14.773 34.9169 16.4576 32.3248 16.5177 30.0898C16.5778 27.8548 14.9906 26.8233 12.9726 27.7858C10.9545 28.7483 9.26992 31.3405 9.20983 33.5755C9.14974 35.8105 10.737 36.842 12.755 35.8795ZM29.1404 24.0691C29.0803 26.3041 27.3957 28.8962 25.3776 29.8587C23.3596 30.8213 21.7724 29.7897 21.8325 27.5547C21.8926 25.3197 23.5772 22.7276 25.5952 21.7651C27.6133 20.8025 29.2005 21.834 29.1404 24.0691ZM38.0003 23.838C40.0183 22.8755 41.703 20.2834 41.7631 18.0484C41.8231 15.8134 40.2359 14.7818 38.2179 15.7444C36.1999 16.7069 34.5153 19.299 34.4552 21.534C34.3951 23.769 35.9823 24.8006 38.0003 23.838Z",
  fill: "#768FFF"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "filter0_i",
  x: 0.213989,
  y: 0.341431,
  width: 51.1895,
  height: 53.7971,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), React.createElement("feOffset", {
  dx: 1,
  dy: 1
}), React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow"
})));

var SvgSubtract = function SvgSubtract(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 52,
    height: 55,
    viewBox: "0 0 52 55",
    fill: "none",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSubtract, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/subtract.1eabd0c2.svg";
export { ForwardRef as ReactComponent };